<template>
  <div class="wg-news">
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title class="primary white--text">Новости</v-card-title>
          <v-card-text
            v-if="!loading && news && news.length"
            class="dashboard__card-text pt-3">
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="3"
                @click="getPublication(item.id)"
                v-for="item in news"
                :key="item.id"
              >
                <v-card class="wg-news__card">
                  <v-img
                    :src="`${item.image_preview_url || 'https://dummyimage.com/600x450/bebebe/fff.jpg&text=%D0%9D%D0%95%D0%A2+%D0%A4%D0%9E%D0%A2%D0%9E'}`"
                    aspect-ratio="1.8"
                    class="wg-news__img"
                  ></v-img>
                  <v-card-title
                    class="wg-news__title d-inline-block text-truncate"
                    style="max-width: 100%;"
                  >{{item.title}}</v-card-title>
                  <v-card-subtitle class="wg-news__date">{{item.created_at}}</v-card-subtitle>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text class="pa-5 text-center" v-if="loading">
            <v-progress-circular
              :width="3"
              color="#0075a8"
              indeterminate
            ></v-progress-circular>
          </v-card-text>
          <v-card-text v-if="!loading && !news.length">
            <p>Список новостей пуст...</p>
          </v-card-text>
          <v-card-actions class="pa-3">
            <v-btn text small to="/news">
              <span>Все новости</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ['news', 'loading'],
  methods: {
    getPublication(id) {
      console.log(id);
      this.$router.push(`/publication/${id}`);
    },
  },
};
</script>

<style lang="scss">
@use '../../assets/scss/variables';

  .wg-news {
    &__card {
      cursor: pointer;
    }
    &__title {
      color: variables.$wn-title-color;
      font-size: 14px!important;
    }
  }
</style>
